"use client"

import { useState } from "react"

export function VpnNotice() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false
    return !sessionStorage.getItem("vpn_notice_seen")
  })

  const handleClose = () => {
    sessionStorage.setItem("vpn_notice_seen", "1")
    setShow(false)
  }

  if (!show) return null

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#03152d]/70 px-[23px] backdrop-blur-[2px]">
      <section className="relative w-full max-w-[344px] rounded-[32px] border border-cyan-200/45 bg-[#0a4260]/85 px-[28px] py-[30px] text-center text-white shadow-2xl">
        <h2 className="text-[28px] font-black leading-none">Важное сообщение</h2>
        <p className="mt-5 text-[16px] font-semibold leading-[130%]">
          С включенным VPN контент может загружаться нестабильно.
          Для корректной работы WebAR рекомендуем отключить VPN и обновить страницу.
        </p>
        <button
          type="button"
          onClick={handleClose}
          className="mt-7 h-[60px] w-[194px] rounded-[33px] border border-white/25 bg-[linear-gradient(2.18deg,rgba(90,159,211,0.75)_-7.97%,rgba(68,43,80,0.75)_18.69%,rgba(29,43,80,0.75)_67.01%,rgba(90,159,211,0.75)_117.15%)] text-[18px] font-black lowercase text-white shadow-[0_0_20px_rgba(0,0,0,0.25)] backdrop-blur-[2px]"
        >
          понятно
        </button>
      </section>
    </div>
  )
}
